export const BRAND = {
  name: "OVI",
  tagline: "The Sound of Making.",
  subline: "Real textiles. Real makers. Direct from India's craft clusters.",
  whatsappNumber: "910000000000",
  whatsappDisplay: "+91 00000 00000",
  whatsappLaunchNote: "Live number updated at launch.",
  instagramHandle: "@ovimakers",
  instagramUrl: "https://instagram.com/ovimakers",
  websiteDisplay: "ovimakers.com",
};

export const NAV_LINKS = [
  { to: "/", label: "Home", testid: "nav-link-home" },
  { to: "/trade", label: "Trade", testid: "nav-link-trade" },
  { to: "/makers", label: "Makers", testid: "nav-link-makers" },
  { to: "/verified", label: "Verified", testid: "nav-link-verified" },
  { to: "/about", label: "About", testid: "nav-link-about" },
];

export const PRODUCT_TYPES = [
  "Bed sheets",
  "Chaddars",
  "Terry towels",
  "Denim",
  "Other",
];

export const TRADE_CATEGORIES = [
  "Bed Sheets",
  "Chaddars",
  "Terry Towels",
  "Denim Fabric",
  "Mixed Order",
];

export const PARTNERSHIP_NATURES = [
  "Government Scheme",
  "Procurement",
  "Export Promotion",
  "Research",
  "Other",
];

export const CATEGORY_LABEL = {
  bed_sheets: "Bed sheets",
  chaddars: "Chaddars",
  terry_towels: "Terry towels",
  denim: "Denim",
};
